import {KatDatePicker} from '@amzn/katal-react';
import React from 'react';
import {getRequiredLabel} from '../../components/custom_widgets/widgetUtil';
import {Translation} from 'react-i18next';
import { WidgetProps } from 'react-jsonschema-form';

class DateWidget extends React.Component<WidgetProps> {

    handleChange = (evt: any, onChange: Function) => {
        evt.preventDefault();

        /**
         * react-jsonschema-form only supports 'YYYY-MM-DD' for date.
         * Hence get the string before 'T' from the isoValue.
         * e.g. '2019-11-21T08:00:00.000Z' --> '2019-11-21'
         */
        const dateValue = evt.target.isoValue.split('T')[0];
        onChange(dateValue);
    };

    render() {
        const { value, onChange, disabled, label, required } = this.props;

        return (
            <div style={{marginBottom: 15 }}>
                <Translation>
                    {(t) => 
                        <KatDatePicker
                            locale="en-US"
                            disabled={disabled}
                            label={getRequiredLabel(required, label)}
                            value={value + 'T00:00:00.000Z'} /* Katal widget expects ISO value, append default ISO string to YYYY-MM-DD */
                            onChange={(evt: any) => this.handleChange(evt, onChange)}
                        />
                    }
                </Translation>
            </div>
        );
    }
}

export default DateWidget;
